<template>
  <div>
    <tableCom
      v-loading="loading"
      :items="items"
      :fields="fields"
      :title="title"
      :goPath="goPath"
      @search="search"
    />
  </div>
</template>

<script>
import tableCom from './component/tableCom.vue'
import { getLatestNews } from '@/api/latestNews'

export default {
  components: { tableCom },
  data() {
    return {
      title: '最新消息',
      goPath: 'latestNews-detail',
      loading: false,
      selectYear: '',
      items: [],
      fields: [
        {
          key: 'id',
          label: 'E_ID',
          sortable: true
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true
        },
        {
          key: 'title',
          label: 'Title',
          sortable: true
        },
        {
          key: 'action',
          label: 'Action'
        }
      ]
    }
  },
  mounted() {
    this.getLatestNews()
  },
  methods: {
    search(val) {
      this.selectYear = val
      this.getLatestNews()
    },
    getLatestNews() {
      this.loading = true
      const data = {
        year: this.selectYear
      }
      getLatestNews(data)
        .then((res) => {
          this.items = res.data.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
